import React, { useState, useEffect } from "react";
import { useParams } from "react-router";
import { SNETButton } from "shared/dist/components";
import { DEMO, LAUNCH } from "../../Routes";
import { useDispatch, useSelector } from "react-redux";
import { aiServiceDetailsActions } from "../../../../Services/Redux/actionCreators";
import validator from "shared/dist/utils/validator";
import { servicePricingValidationConstraints } from "../validationConstraints";
import { serviceTypes } from "../../../../Utils/serviceTypes";

import { cogsToAgi } from "shared/dist/utils/Pricing";
import { progressStatus, sections } from "../../constant";
import { setCreateNewAiService } from "../../../../Services/Redux/actionCreators/aiServiceDetailsActions";
import { isUndefined } from "lodash";
import { useNavigateTo } from "../../../../GlobalRouter/hook/NavigateTo";
import FormActions from "../../../../Components/PageFormComponents/FormActions";
import { useProtoFileCountSelector } from "../../../../Services/Redux/selectors/aiServiceDetailsSelector";

const Actions = () => {
    const navigateTo = useNavigateTo();
    const serviceDetails = useSelector((state) => state.aiServiceDetails);
    const backendProtoFileCount = useProtoFileCountSelector();
    const { orgUuid, serviceUuid } = useParams();
    const dispatch = useDispatch();
    const [isDisableContinueButton, setIsDisableContinueButton] = useState(true);

    useEffect(() => {
        const isFormInvalid = () => {
            let invalidFields = validator(serviceDetails, servicePricingValidationConstraints, {
                format: "flat",
            });
            const isValidHTTPProto =
                serviceDetails.serviceType === serviceTypes.HTTP
                    ? backendProtoFileCount === 1
                    : true;

            return (
                !isUndefined(invalidFields) ||
                !serviceDetails.groups[0].pricing[0].priceInCogs >= cogsToAgi(1) ||
                !isValidHTTPProto
            );
        };

        setIsDisableContinueButton(isFormInvalid());
    }, [serviceDetails, backendProtoFileCount]);

    const handleBack = () => {
        navigateTo.aiServiceCreation({ orgUuid, serviceUuid }, DEMO.path);
    };

    const handleSave = async () => {
        await dispatch(aiServiceDetailsActions.saveServiceDetails(orgUuid, serviceDetails));
        dispatch(aiServiceDetailsActions.setSavedPricingDetails(true));
    };

    const handleContinue = async () => {
        await handleSave();
        dispatch(
            aiServiceDetailsActions.updateProgressStatus(
                sections.PRICING_AND_DISTRIBUTION,
                progressStatus.PENDING,
                serviceDetails.progressStages
            )
        );
        navigateTo.aiServiceCreation({ orgUuid, serviceUuid }, LAUNCH.path);
    };

    const handleFinishLater = async () => {
        dispatch(setCreateNewAiService(false));
        await handleSave();
        navigateTo.services({ orgUuid });
    };

    return (
        <FormActions>
            <SNETButton variant="outlined" children="finish later" onClick={handleFinishLater} />
            <SNETButton variant="outlined" children="previous step" onClick={handleBack} />
            <SNETButton
                color="primary"
                variant="contained"
                children="continue"
                disabled={isDisableContinueButton}
                onClick={handleContinue}
            />
        </FormActions>
    );
};

export default Actions;
